import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const authHeaders = () => {
  const token = localStorage.getItem('authToken');
  return { Authorization: token ? `Bearer ${token}` : '' };
};

const StockTransferController = {
  paginate: async (page = 1, size = 20, params = {}) => {
    const q = new URLSearchParams({ Size: size, PageNumber: page });
    if (params.sourceDepotId) q.set('SourceDepotId', params.sourceDepotId);
    if (params.destinationDepotId) q.set('DestinationDepotId', params.destinationDepotId);
    if (params.from) q.set('From', params.from);
    if (params.to) q.set('To', params.to);
    const r = await axios.get(`${API_URL}/StockTransfer/Pagination?${q}`, { headers: authHeaders() });
    return r.data;
  },
  getById: async (id) => {
    const r = await axios.get(`${API_URL}/StockTransfer/byId/${id}`, { headers: authHeaders() });
    return r.data;
  },
  save: async (entet, line) => {
    const r = await axios.post(
      `${API_URL}/StockTransfer/Save`,
      { entet, line },
      { headers: authHeaders() }
    );
    return r.data;
  },
};

export default StockTransferController;
